import {createFileRoute} from '@tanstack/react-router';
import {StatementPaymentOptionsPage} from 'features/statement-payment/pages/StatementPaymentOptionsPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/_payment/options',
)({
  component: StatementPaymentOptionsPage,
});
